export type SwiperPhoto = {
  url: string;
  alt: string;
};
